import React from "react";

interface IProps {
    options: string[];
}

interface IState {}

// TODO(ssr, LEVEL 1 out of 10): Migrate this component from class-style to functional-style. Rated LOE as 1/10 due to simple map rendering with no state or lifecycle methods.
export class SelectOptions extends React.PureComponent<IProps, IState> {
    render() {
        return (
            <>
                {this.props.options.map((option) => {
                    return (
                        // TODO(i18n): Translate option labels with t tagged template: {t`${option}`}
                        <option key={option} value={option}>
                            {option}
                        </option>
                    );
                })}
            </>
        );
    }
}
